import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { onMounted, ref, watch } from "vue";
import { withPrefix } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridDatasets',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const historyStats = ref(null);
        async function getCounts() {
            historyStats.value = null;
            if (props.historyId) {
                try {
                    const { data } = await axios.get(withPrefix(`/api/histories/${props.historyId}?keys=nice_size,contents_active,contents_states`));
                    historyStats.value = data;
                }
                catch (e) {
                    rethrowSimple(e);
                }
            }
        }
        onMounted(() => {
            getCounts();
        });
        watch(() => props.historyId, () => getCounts());
        return { __sfc: true, props, historyStats, getCounts };
    }
});
